<template>
  <validated-form
    ref="form"
    auto-focus
    form-id="addDeliveryServiceForm"
    @valid-submit="updateMerchantDeliveryService"
  >
    <modal-card
      title="Update Delivery Service"
      :subtitle="deliveryServiceName"
    >
      <div class="is-flex-column align-start">
        <b-switch
          v-model="form.isActive"
          class="label left-label mar-b-lg"
        >
          Active
        </b-switch>
      </div>

      <validated-text-input
        v-model="apiConfiguration"
        class="configuration"
        :has-icon="false"
        label="Configuration"
        name="paymentGatewayConfig"
        type="textarea"
        rows="20"
        :spellcheck="false"
        maxlength="16384"
        monospaced
        rules="required|validJSON"
      />

      <template #footer>
        <div class="buttons all-bold">
          <b-button
            rounded
            @click="$_confirmCloseModal({ programmatic: true })"
          >
            Cancel
          </b-button>
          <b-button
            v-tabbable
            rounded
            native-type="submit"
            type="is-primary"
            :loading="isSubmitting"
          >
            Save
          </b-button>
        </div>
      </template>
    </modal-card>
  </validated-form>
</template>

<script>
  import beautify from 'json-beautify';

  import confirmModalCloseMixin from '@/mixins/confirm-modal-close';

  import MerchantDeliveryService from '@/store/classes/MerchantDeliveryService';


  export default {
    name: 'EditMerchantDeliveryServiceModal',

    mixins: [confirmModalCloseMixin],

    props: {
      merchantDeliveryService: {
        type: Object,
        required: true
      },

      deliveryServiceName: {
        type: String,
        required: true
      },

      merchantId: {
        type: Number,
        required: true
      }
    },

    data() {
      return {
        form: {}
      };
    },

    computed: {
      isSubmitting() {
        return MerchantDeliveryService.$state().submitting;
      },

      apiConfiguration: {
        get() {
          return beautify(JSON.parse(this.form.apiConfiguration), null, 2, 0);
        },

        set(value) {
          this.form.apiConfiguration = value;
        }
      }
    },

    created() {
      this.onCreated();
    },

    methods: {
      onCreated() {
        this.form = this.$clone(this.merchantDeliveryService);
      },

      async updateMerchantDeliveryService() {
        try {
          await MerchantDeliveryService.updateMerchantDeliveryService({
            merchantDeliveryService: {
              ...this.form,
              apiConfiguration: beautify(JSON.parse(this.form.apiConfiguration), null, 0)
            },
            merchantId: this.merchantId
          });

          this.$_onRequestSuccess({
            toastOptions: { message: `Successfully updated the ${this.deliveryServiceName} delivery service!` },
            options: { closeParent: true }
          });
        }
        catch (error) {
          this.$_onRequestError({
            error,
            toastOptions: {
              message: `There was an error updating the ${this.deliveryServiceName} delivery service`
            }
          });
        }
      }
    }
  };
</script>

<style lang="sass" scoped>
  .modal-card
    overflow: visible

    .modal-card-body
      overflow: visible
</style>
